import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import StatutoryRemittancesComp from './StatutoryRemittancesComp';

function StatutoryRemittances() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <StatutoryRemittancesComp />
      </div>
    </div>
  );
}

export default StatutoryRemittances;
